import moment from "moment";
import React, { useEffect, useState } from "react";
import { BsX } from "react-icons/bs";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { Button, Form } from "react-bootstrap";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import CardDiv from "modules/common/card-div/CardDiv";
import { useInvoiceStore } from "./store";
import { useToast } from "modules/navbar/top/store/toasterStore";
import { validateEmail, formatDate } from "modules/utilities/utility";

const DownloadInvoiceReport = ({ source }) => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [email, setEmail] = useState("");
  const [reportType, setReportType] = useState(null);
  const { postDownloadInvoice } = useInvoiceStore();
  const { setToaster } = useToast();
  const [clear, setClear] = useState(false);
  const [isValidEmail, setIsValidEmail] = useState(true);
  const [numberOfDays, setNumberOfDays] = useState(60);
  const [isValidNumberOfDays, setIsValidNumberOfDays] = useState(true);

  useEffect(() => {
    if (clear) {
      setStartDate(null);
      setEndDate(null);
      setEmail(null);
      setReportType(null);
      setClear(false);
    }
  }, [clear]);

  const handleSubmit = () => {
    let sd;
    let ed;

    sd = moment(startDate).startOf("day").toISOString();
    ed = moment(endDate).endOf("day").toISOString();

    if (source === "agent_case_order_count_wise_assignment_report") {
      sd = moment().subtract(numberOfDays, 'days').startOf('day').toISOString();
      ed = null;
    }

    postDownloadInvoice(
      {
        startDate: sd,
        endDate: ed,
        email: email,
        reportType: source ? source === "agent_case_order_count_wise_assignment_report"
          ? "agent_case_order_count_wise_assignment_report"
          : "order_transaction_report"
          : reportType,
      },
      setToaster,
      clear,
      setClear
    );
  };

  const handleStartDateChange = (date) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };

  const handleResetStartDate = () => {
    setStartDate("");
  };

  const handleResetEndDate = () => {
    setEndDate("");
  };

  const handleReportTypeChange = (e) => {
    setReportType(e.target.value);
  };

  const handleEmailChange = (event) => {
    const enteredEmail = event.target.value;
    setEmail(enteredEmail);
    setIsValidEmail(validateEmail(enteredEmail));
  };

  const handleNumberOfDaysChange = (e) => {
    setNumberOfDays(e.target.value);
    if (e.target.value > 0) {
      setIsValidNumberOfDays(true);
    } else {
      setIsValidNumberOfDays(false);
    }
  };

  return (
    <>
      {source !== "agent_case_order_count_wise_assignment_report" ? (
        <CardDiv
          title={
            <div className="w-25">
              <Form.Select
                onChange={handleReportTypeChange}
                value={source ? "order_transaction_report" : reportType}
                className="custom-select"
                disabled={source}
              >
                <option value="">Select</option>
                <option value="invoice">Invoice Report</option>
                <option value="cn">Credit Note Report</option>
                <option value="all_order_report">All Order Report</option>
                <option value="invoices_left">
                  Invoices Left to be Processed Report
                </option>
                <option value="cn_left">
                  Credit Notes Left to be Processed Report
                </option>
                <option value="order_sales_report">Order Sales Report</option>
              </Form.Select>
            </div>
          }
          component={
            <div style={{ minHeight: "20vh" }}>
              {(reportType !== null || source) && (
                <div>
                  <div className="d-flex flex-row gap-3 mt-5">
                    <Form.Group>
                      <div className="input-container-summary mt-1">
                        {startDate ? (
                          ""
                        ) : (
                          <div className="calendar-icon-container-summary">
                            <FontAwesomeIcon
                              icon={faCalendarAlt}
                              className="calendar-icon"
                            />
                          </div>
                        )}
                        <DatePicker
                          selected={startDate}
                          onChange={handleStartDateChange}
                          placeholderText="Start Date"
                          dateFormat="dd-MM-yyyy"
                          value={startDate ? formatDate(startDate) : ""}
                          className="input-with-icon"
                          maxDate={new Date()}
                        />
                        {startDate && (
                          <span
                            className="reset-icon"
                            onClick={handleResetStartDate}
                          >
                            <BsX />
                          </span>
                        )}
                      </div>
                    </Form.Group>
                    <Form.Group>
                      <div className="input-container-summary mt-1">
                        {endDate ? (
                          ""
                        ) : (
                          <div className="calendar-icon-container-summary">
                            <FontAwesomeIcon
                              icon={faCalendarAlt}
                              className="calendar-icon"
                            />
                          </div>
                        )}
                        <DatePicker
                          selected={endDate}
                          onChange={handleEndDateChange}
                          placeholderText="End Date"
                          dateFormat="dd-MM-yyyy"
                          maxDate={new Date()}
                          minDate={startDate}
                          value={endDate ? formatDate(endDate) : ""}
                        />
                        {endDate && (
                          <span
                            className="reset-icon"
                            onClick={handleResetEndDate}
                          >
                            <BsX />
                          </span>
                        )}
                      </div>
                    </Form.Group>
                    <Form.Group controlId="email" className="mt-1">
                      <Form.Control
                        type="email"
                        placeholder="john@gmail.com"
                        value={email}
                        onChange={handleEmailChange}
                        isInvalid={!isValidEmail}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please enter a valid email address.
                      </Form.Control.Feedback>
                    </Form.Group>
                    <OverlayTrigger
                      overlay={
                        <Tooltip style={{ position: "fixed" }} id="tooltip-example">
                          <div className="fw-bold">Report will be sent to provided email</div>
                        </Tooltip>
                      }
                    >
                      <div className="ms-n2 mt-2">
                        <span className="text-black border px-1 fs-1 mt-2 rounded-circle cursor-pointer fw-bold">
                          i
                        </span>
                      </div>
                    </OverlayTrigger>
                    <Button
                      variant="primary"
                      onClick={handleSubmit}
                      disabled={!startDate || !endDate || !email || !isValidEmail}
                      id="generate_report_btn"
                    >
                      Generate Report
                    </Button>
                  </div>
                </div>
              )}
            </div>
          }
        />
      ) : (
        <CardDiv
          component={
            <div style={{ minHeight: "20vh" }}>
              <div className="d-flex align-items-center gap-3 mt-5">
              <Form.Group>
              <Form.Label>Enter Number of Days</Form.Label>
              <Form.Control
                type="number"
                value={numberOfDays}
                onChange={handleNumberOfDaysChange}
                placeholder="Enter number of days"
                style={{
                  width: "150px",
                  borderColor: !isValidNumberOfDays ? "red" : "", // Conditional red border for invalid input
                }}
                isInvalid={!isValidNumberOfDays}
              />
              {!isValidNumberOfDays && (
                <div style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
                  The number of days should be greater than 0.
                </div>
              )}
            </Form.Group>

                <Form.Group controlId="email">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="john@gmail.com"
                    value={email}
                    onChange={handleEmailChange}
                    isInvalid={!isValidEmail}
                    style={{ width: "250px" }}
                  />
                  <Form.Control.Feedback type="invalid">
                    Please enter a valid email address.
                  </Form.Control.Feedback>
                </Form.Group>
                <OverlayTrigger
                  overlay={
                    <Tooltip id="tooltip-example">
                      <div className="fw-bold">Report will be sent to provided email</div>
                    </Tooltip>
                  }
                >
                  <div className="ms-n2 mt-4">
                    <span className="text-black border px-2 py-1 rounded-circle cursor-pointer fw-bold">
                      i
                    </span>
                  </div>
                </OverlayTrigger>
                <Button
                  variant="primary"
                  onClick={handleSubmit}
                  disabled={!email || !isValidEmail || !isValidNumberOfDays || numberOfDays <= 0}
                  id="generate_report_btn"
                  className="ms-3 mt-4"
                >
                  Generate Report
                </Button>
              </div>
            </div>
          }
        />
      )}
    </>
  );
};

export default DownloadInvoiceReport;
